import i18n from '@/i18n';

import {
  LOGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,

  LOGOUT,

  VERIFY,
  VERIFY_ERROR,
  VERIFY_SUCCESS,

  SAVE_SETTINGS,
  SAVE_SETTINGS_ERROR,
  SAVE_SETTINGS_SUCCESS,

  // SAVE_PFCONTRIBUTION,
  // SAVE_PFCONTRIBUTION_SUCCESS,
  // SAVE_PFCONTRIBUTION_ERROR,

  FORGOT_PASSWORD,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_SUCCESS,

  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_SUCCESS,

  UPDATE_FISCAL_YEAR,

  TOGGLE_SIDEBAR,
} from './constants';

export default {
  [LOGIN](state) {
    state.currentUser = false;
    state.error = false;
    state.authenticated = false;
    state.formLoading = true;
  },
  [LOGIN_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [LOGIN_SUCCESS](state, payload) {
    localStorage.setItem('access_token', payload.token);
    i18n.locale = payload.user.language.toLowerCase();
    state.currentUser = payload.user;
    state.authenticated = true;
    state.formLoading = false;
  },

  [LOGOUT](state) {
    state.authenticated = false;
    localStorage.removeItem('access_token');
    state.currentUser = false;
  },

  [VERIFY](state) {
    state.currentUser = false;
    state.error = false;
    state.authenticated = false;
    state.loading = true;
  },
  [VERIFY_ERROR](state, payload) {
    localStorage.removeItem('access_token');
    state.error = payload;
    state.loading = false;
  },
  [VERIFY_SUCCESS](state, payload) {
    localStorage.setItem('access_token', payload.token);
    i18n.locale = payload.user.language.toLowerCase();
    state.currentUser = payload.user;
    state.authenticated = true;
    state.loading = false;
  },

  [SAVE_SETTINGS](state) {
    state.error = false;
    state.formLoading = true;
    state.success = false;
  },
  [SAVE_SETTINGS_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_SETTINGS_SUCCESS](state, payload) {
    i18n.locale = payload.language.toLowerCase();
    state.currentUser = payload;
    state.success = true;
    state.formLoading = false;
  },

  // [SAVE_PFCONTRIBUTION](state) {
  //   state.error = false;
  //   state.formLoading = true;
  //   state.success = false;
  // },
  // [SAVE_PFCONTRIBUTION_ERROR](state, payload) {
  //   state.error = payload;
  //   state.formLoading = false;
  // },
  // [SAVE_PFCONTRIBUTION_SUCCESS](state, payload) {
  //   state.userPFCont = payload;
  //   state.success = true;
  //   state.formLoading = false;
  // },

  [FORGOT_PASSWORD](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [FORGOT_PASSWORD_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [FORGOT_PASSWORD_SUCCESS](state, payload) {
    state.success = payload;
    state.loading = false;
  },

  [CHANGE_PASSWORD](state) {
    state.error = false;
    state.formLoading = true;
    state.success = false;
  },
  [CHANGE_PASSWORD_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [CHANGE_PASSWORD_SUCCESS](state) {
    state.success = true;
    state.formLoading = false;
  },

  [UPDATE_FISCAL_YEAR](state, payload) {
    state.fiscalYear = payload;
  },

  [TOGGLE_SIDEBAR](state, payload) {
    localStorage.setItem('sidebarCollapsed', payload);
    state.sidebarCollapsed = payload;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.currentUser[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js